import CustomLink from "./CustomLink";

export default function MahasiswaNavbar() {
  return (
    <CustomLink itemkey="beranda" to="/jadwal-sidang-publik">
      <span className="block py-2 pr-4 pl-3 hover:text-blue-700 rounded md:bg-transparent md:p-0">
        Jadwal Sidang
      </span>
    </CustomLink>
  );
}
